import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { UnpaidRent } from 'types/api'

export interface UnpaidRents {
  unpaid_user_rents: UnpaidRent[]
  unpaid_landlord_payments: UnpaidRent[]
}

export const unpaidRentsQueryKey = ['dashboard-unpaid-rents']

export function useUnpaidRents() {
  async function getRents(): Promise<UnpaidRents> {
    const response = await apiClient.get<UnpaidRents>(
      SNA_PREFIX + 'dashboard/unpaid-rents'
    )
    return response.data
  }

  return useQuery({
    queryFn: getRents,
    queryKey: unpaidRentsQueryKey
  })
}
